import { render, staticRenderFns } from "./DieticianSelect.vue?vue&type=template&id=02599074&"
import script from "./DieticianSelect.vue?vue&type=script&lang=js&"
export * from "./DieticianSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports